import { Slider as SliderPrimitive } from "@base-ui/react/slider"
import type * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Base UI Slider (OKS-697). `npx shadcn add slider` ships a Radix
 * implementation, but first-party Radix was removed from Crew (OKS-613/651) and is
 * lint-banned — so this primitive is conformed to `@base-ui/react`, mirroring
 * the already-migrated `switch.tsx` / `progress.tsx`. API surface matches Base
 * UI's `Slider.Root` (single-value `value: number` or range `number[]`).
 */
function Slider({
  className,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Root>) {
  return (
    <SliderPrimitive.Root
      data-slot="slider"
      className={cn(
        "relative w-full touch-none select-none data-disabled:opacity-50",
        className,
      )}
      {...props}
    >
      <SliderPrimitive.Control className="flex w-full items-center py-2">
        <SliderPrimitive.Track className="bg-muted relative h-1.5 w-full grow overflow-hidden rounded-full">
          <SliderPrimitive.Indicator className="bg-primary absolute h-full rounded-full" />
          <SliderPrimitive.Thumb className="border-primary ring-ring/50 block size-4 shrink-0 rounded-full border bg-white shadow-sm transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50" />
        </SliderPrimitive.Track>
      </SliderPrimitive.Control>
    </SliderPrimitive.Root>
  )
}

export { Slider }
